import React from "react";
import PropTypes from "prop-types";
import { useAppTranslation } from "../../../../../../../i18n/useAppTranslation";
import classes from "./FrontImage.module.scss";
import { InputLabel } from "../../../../../../../shared/InputLabel/InputLabel";
import { ImageUploader } from "../../../../../../../boxes/ImageUploader/ImageUploader";
import {
  IMAGE_COMPRESS_WIDTH,
  IMAGE_UPLOAD_TYPE,
} from "../../CosmeticCreateEdit.consts";
import { useDefaultImage } from "../../hooks/useDefaultImage";
import { Skeleton } from "../../../../../../../shared/Skeleton/Skeleton";
import { useImageUploader } from "../../../../../../../hooks/useImageUploader";
import { UPLOAD_MEDIA_TYPE } from "../../../../../../../api/mutations/useUploadMediaMutation";
import { getCosmeticPathParams } from "../../CosmeticCreateEdit.utils";
import { useClientQuery } from "../../../../../../../api/queries/useClientQuery";
import { PROCEDURE_AREA } from "../Info/Info.consts";
import { uiNotification } from "../../../../../../../services/UINotificationService";

export function FrontImage({
  image,
  isLoading,
  setProfileImage,
  procedureArea,
  onUploadingChange,
  onUploadSuccess,
  isImagesUploading,
}) {
  const { isEditMode, clientId } = getCosmeticPathParams();
  const { tClients } = useAppTranslation.Clients();
  const defaultImage = useDefaultImage();
  const { data: client } = useClientQuery({ clientId });

  const uploader = useImageUploader({
    uploadType: IMAGE_UPLOAD_TYPE,
    onLoadingChange: onUploadingChange,
    compress: {
      width: IMAGE_COMPRESS_WIDTH,
    },
  });

  const profileImageUploader = useImageUploader({
    uploadType: UPLOAD_MEDIA_TYPE.patientProfilePhoto,
    compress: {
      width: IMAGE_COMPRESS_WIDTH,
    },
  });

  const uploadImage = (e) => {
    if (isImagesUploading) {
      return uiNotification.warn(
        tClients("createEditCosmeticProcedure.warn.uploadingImages"),
      );
    }
    uploader.htmlOnChange(e).then((res) => {
      image.onChange(res?.uploadedFileFullPath);
      if (
        !isEditMode &&
        procedureArea === PROCEDURE_AREA.face &&
        !client?.profileImageUrl
      ) {
        profileImageUploader
          .initiate(res?.originalFile)
          .then(({ uploadedFileName }) => setProfileImage(uploadedFileName));
      }
      onUploadSuccess();
    });
  };

  return (
    <div>
      <div className={classes.title}>
        {tClients("createEditCosmeticProcedure.images.procedureFront")}
      </div>
      {isLoading ? (
        <Skeleton count={1} height={137} width="122px" borderRadius="4px" />
      ) : (
        <div>
          <InputLabel>
            {tClients("createEditCosmeticProcedure.images.front")}
          </InputLabel>
          <ImageUploader
            name="frontImage"
            value={image.value}
            isLoading={uploader.isLoading}
            onChange={(e) => uploadImage(e)}
            onRemove={() => image.onChange(null)}
            defaultImage={defaultImage}
          />
        </div>
      )}
    </div>
  );
}

FrontImage.propTypes = {
  image: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  isLoading: PropTypes.bool,
  setProfileImage: PropTypes.func,
};
